import React, { useState, useEffect } from 'react';
import '../assets/css/Contact.css';
import emailjs from '@emailjs/browser';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Initialize EmailJS with your public key
    emailjs.init('9YuUHu2AYUD10sEUr');
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs.send('service_nhtqx3d', 'template_f3hmedn', templateParams)
      .then((response) => {
        console.log('Email sent successfully:', response);
        alert('Thank you for your inquiry! We will get back to you soon.');
        setFormData({ name: '', email: '', phone: '', message: '' });
      })
      .catch((error) => {
        console.error('Failed to send email:', error);
        alert('Failed to send inquiry. Error: ' + error.text + '. Please try again or contact us directly at (044)4 711 816');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    
    <section id="contact" className="contact">
      <div className="container">
        <h2>Get in Touch</h2>
        <p className="section-subtitle">"FOR EVERY HOUSE IS BUILT BY SOMEONE, BUT THE 
            BUILDER OF ALL THINGS IS GOD." -HEBREWS 3:4</p>
        <div className="contact-wrapper">
          
          <div className="contact-info">
            <div className="info-item">
              <h3>Address</h3>
              <p>9001 GEMELINA ST. STA CLARA, SANTA MARIA BULACAN</p>
            </div>
            <div className="info-item">
              <h3>Phone</h3>
              <p>(044)4 711 816</p>
            </div>
            <div className="info-item">
              <h3>Email</h3>
              <p>meconsteel88construction@gmail.com</p>
            </div>
            <div className="info-item">
              <h3>Business Hours</h3>
              <p>Monday - Friday: 8:00 AM - 6:00 PM<br />Saturday: 9:00 AM - 4:00 PM</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Your Message"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-button" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Inquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;
